import { AuxiliumComponent } from "../auxilium-component";

export default class Breadcrumb extends AuxiliumComponent {
	static observable = ["description", "size"];

	constructor() {
		super();

		this.description ??= "Breadcrumb";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("nav", document.createElementWithContents("ol", [...this.children ?? []].map(x => document.createElementWithContents("li", x)), {
			className: "breadcrumb-list"
		}), { ariaLabel: this.description }));
	}
}
